class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }

    this.setHeaderCartIconAccessibility();

    this.cartToastTimer = null;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');

    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute('role')
    ) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');

        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');

        trapFocus(
          containerToTrapFocusOn,
          focusElement
        );
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');

    removeTrapFocus(this.activeElement);

    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (
      cartDrawerNote.nextElementSibling &&
      cartDrawerNote.nextElementSibling.getAttribute('id')
    ) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener(
      'keyup',
      onKeyUpEscape
    );
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');

    if (
      drawerInner &&
      drawerInner.classList.contains('is-empty')
    ) {
      drawerInner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');

      if (overlay) {
        overlay.addEventListener(
          'click',
          this.close.bind(this)
        );
      }

      /*
       * Der Cart Drawer wird beim Hinzufügen
       * NICHT automatisch geöffnet.
       *
       * Der Warenkorb selbst wird trotzdem
       * vollständig aktualisiert.
       *
       * Stattdessen erscheint die grüne Meldung.
       */

      this.showCartToast();
    });
  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    const parsedDocument = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const element =
      parsedDocument.querySelector(selector);

    return element
      ? element.innerHTML
      : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    return new DOMParser()
      .parseFromString(
        html,
        'text/html'
      )
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }


  /* =========================================================
     GRÜNE ERFOLGSMELDUNG
     ========================================================= */

  showCartToast() {
    let toast =
      document.getElementById('hs-cart-toast');

    if (!toast) {
      toast =
        document.createElement('div');

      toast.id =
        'hs-cart-toast';

      toast.setAttribute(
        'role',
        'status'
      );

      toast.setAttribute(
        'aria-live',
        'polite'
      );

      toast.innerHTML = `
        <div class="hs-cart-toast__icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="2"
            ></circle>

            <path
              d="M7.5 12.2L10.4 15.1L16.8 8.8"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>

        <div class="hs-cart-toast__text">
          Erfolgreich zum
          <a href="/cart">Warenkorb</a>
          hinzugefügt
        </div>

        <button
          type="button"
          class="hs-cart-toast__close"
          aria-label="Meldung schließen"
        >
          ×
        </button>
      `;

      document.body.appendChild(
        toast
      );

      const closeButton =
        toast.querySelector(
          '.hs-cart-toast__close'
        );

      if (closeButton) {
        closeButton.addEventListener(
          'click',
          () => {
            this.hideCartToast();
          }
        );
      }

      this.createCartToastStyles();
    }

    if (
      this.cartToastTimer
    ) {
      clearTimeout(
        this.cartToastTimer
      );
    }

    toast.classList.remove(
      'is-visible'
    );

    /*
     * Browser zwingt zu einem neuen Rendering.
     * Dadurch funktioniert die Animation auch bei
     * mehreren schnellen "In den Warenkorb"-Klicks.
     */

    void toast.offsetWidth;

    toast.classList.add(
      'is-visible'
    );

    this.cartToastTimer =
      setTimeout(() => {
        this.hideCartToast();
      }, 4000);
  }


  hideCartToast() {
    const toast =
      document.getElementById(
        'hs-cart-toast'
      );

    if (toast) {
      toast.classList.remove(
        'is-visible'
      );
    }

    if (
      this.cartToastTimer
    ) {
      clearTimeout(
        this.cartToastTimer
      );

      this.cartToastTimer =
        null;
    }
  }


  /* =========================================================
     DESIGN DER ERFOLGSMELDUNG
     ========================================================= */

  createCartToastStyles() {
    if (
      document.getElementById(
        'hs-cart-toast-styles'
      )
    ) {
      return;
    }

    const style =
      document.createElement(
        'style'
      );

    style.id =
      'hs-cart-toast-styles';

    style.textContent = `

      /* =======================================================
         DESKTOP / LAPTOP
         BLEIBT WIE BISHER
         ======================================================= */

      #hs-cart-toast {
        position: fixed !important;

        top: 22px !important;
        left: 50% !important;

        z-index: 2147483647 !important;

        display: flex !important;
        align-items: center !important;
        justify-content: center !important;

        gap: 10px !important;

        width: auto !important;
        max-width: calc(100% - 30px) !important;

        padding: 14px 18px !important;

        margin: 0 !important;

        background: #ecfdf3 !important;

        border:
          1px solid #15945a !important;

        border-radius:
          12px !important;

        box-shadow:
          0 10px 30px
          rgba(0, 0, 0, 0.16) !important;

        color: #087443 !important;

        font-family:
          inherit !important;

        opacity: 0 !important;

        visibility:
          hidden !important;

        pointer-events:
          none !important;

        transform:
          translate(-50%, -18px) !important;

        transition:
          opacity 0.25s ease,
          transform 0.25s ease,
          visibility 0.25s ease !important;
      }


      #hs-cart-toast.is-visible {
        opacity: 1 !important;

        visibility:
          visible !important;

        pointer-events:
          auto !important;

        transform:
          translate(-50%, 0) !important;
      }


      #hs-cart-toast
      .hs-cart-toast__icon {
        display: flex !important;

        align-items:
          center !important;

        justify-content:
          center !important;

        flex:
          0 0 auto !important;

        color:
          #087443 !important;
      }


      #hs-cart-toast
      .hs-cart-toast__text {
        margin: 0 !important;

        padding: 0 !important;

        color:
          #087443 !important;

        font-size:
          15px !important;

        font-weight:
          600 !important;

        line-height:
          1.35 !important;

        white-space:
          nowrap !important;
      }


      #hs-cart-toast
      .hs-cart-toast__text a {
        color:
          #087443 !important;

        font-weight:
          800 !important;

        text-decoration:
          underline !important;

        text-underline-offset:
          2px !important;

        opacity:
          1 !important;

        transform:
          none !important;
      }


      #hs-cart-toast
      .hs-cart-toast__text a:hover,
      #hs-cart-toast
      .hs-cart-toast__text a:focus {
        color:
          #087443 !important;

        opacity:
          1 !important;

        transform:
          none !important;

        text-decoration:
          underline !important;
      }


      #hs-cart-toast
      .hs-cart-toast__close {
        display:
          flex !important;

        align-items:
          center !important;

        justify-content:
          center !important;

        flex:
          0 0 auto !important;

        width:
          26px !important;

        height:
          26px !important;

        min-width:
          26px !important;

        margin:
          0 !important;

        padding:
          0 !important;

        border:
          0 !important;

        background:
          transparent !important;

        color:
          #087443 !important;

        font-family:
          Arial, sans-serif !important;

        font-size:
          24px !important;

        font-weight:
          400 !important;

        line-height:
          1 !important;

        cursor:
          pointer !important;

        box-shadow:
          none !important;

        opacity:
          0.7 !important;
      }


      #hs-cart-toast
      .hs-cart-toast__close:hover {
        opacity:
          1 !important;
      }


      /* =======================================================
         NUR SMARTPHONE

         Die Meldung sitzt weiter unten,
         damit der Sticky Header inklusive Warenkorb
         vollständig sichtbar bleibt.

         DESKTOP WIRD DAVON NICHT VERÄNDERT.
         ======================================================= */

      @media screen and (max-width: 749px) {

        #hs-cart-toast {
          top: 82px !important;

          left: 50% !important;

          width:
            calc(100% - 24px) !important;

          max-width:
            500px !important;

          padding:
            13px 14px !important;

          gap:
            8px !important;

          justify-content:
            flex-start !important;

          transform:
            translate(-50%, -8px) !important;
        }


        #hs-cart-toast.is-visible {
          transform:
            translate(-50%, 0) !important;
        }


        #hs-cart-toast
        .hs-cart-toast__text {
          flex:
            1 1 auto !important;

          font-size:
            14px !important;

          line-height:
            1.35 !important;

          white-space:
            normal !important;
        }


        #hs-cart-toast
        .hs-cart-toast__icon svg {
          width:
            22px !important;

          height:
            22px !important;
        }


        #hs-cart-toast
        .hs-cart-toast__close {
          width:
            24px !important;

          height:
            24px !important;

          min-width:
            24px !important;

          font-size:
            22px !important;
        }

      }

    `;

    document.head.appendChild(
      style
    );
  }
}


customElements.define(
  'cart-drawer',
  CartDrawer
);


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}


customElements.define(
  'cart-drawer-items',
  CartDrawerItems
);